import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login.vue";

// backLog
import Welcome from "../components/backlog/Welcome.vue";
import ModifyPassword from "../components/backlog/student/ModifyPassword";
// 学生模块
import StudentList from "../components/backlog/student/StudentList.vue";
import CreateStudent from "../components/backlog/student/CreateStudent.vue";
import StoreList from "../components/backlog/store/StoreList.vue";
import CreateStore from "../components/backlog/store/CreateStore.vue";
import ImportVipssStudent from "../components/backlog/student/ImportVipssStudent.vue";
import TeachingSchedule from "../components/backlog/student/TeachingSchedule.vue";
import StudentDetail from "../components/backlog/student/StudentDetail.vue";
// 班级模块
import ClassList from "../components/backlog/class/ClassList.vue";
import CreateClass from "../components/backlog/class/CreateClass.vue";
import OneByOneClassList from "../components/backlog/class/OneByOneClassList.vue";
import CreateOneByOne from "../components/backlog/class/CreateOneByOne.vue";
import ClassStudentDetail from "../components/backlog/class/ClassStudentDetail.vue";
// 点名管理
import CallList from "../components/backlog/rollcall/CallList.vue";
// 员工管理
import StaffList from "../components/backlog/staff/StaffList.vue";
// 课程管理
import CourseList from "../components/backlog/course/CourseList.vue";
import CreateCourse from "../components/backlog/course/CreateCourse.vue";
// 套餐管理
import SetMealList from "../components/backlog/setMeal/SetMealList.vue";
import CreateSetMeal from "../components/backlog/setMeal/CreateSetMeal.vue";
// 工资管理
import SetRules from "../components/backlog/salary/SetRules.vue"
import SalaryList from "../components/backlog/salary/SalaryList.vue"
// 上课记录
import ClassRecord from "../components/backlog/classRecord/ClassRecord.vue"
import VipssStudentDetail from "../components/backlog/vipss/vipssStudentDetail.vue"
import VipssStudentCapterStatistics from "../components/backlog/vipss/vipssStudentCapterStatistics.vue"

//主页
import ManagerPage from "../components/ManagerPage.vue";
Vue.use(VueRouter);

const routes = [
  {
    name:'login',
    path: "/",
    redirect: "/login"
  },
  {
    name:'login',
    path: "/login",
    component: Login
  },
  {
    path: "/managerPage",
    component: ManagerPage,
    // 路由守卫
    // beforeEnter: (to, from, next) => {
    //   const tokenStr = window.sessionStorage.getItem("token");
    //   if (!tokenStr) return nex
    // ("/login");
    //   next();
    // },
    redirect: "/welcome",
    children: [
      {
        path: "/welcome",
        component: Welcome
      },
      {
        path: "/studentList",
        component: StudentList,
        name: 'topic',
        meta: {
          perms: ['GET /student/student/list'],
          title: '学生管理',
          noCache: true
        }
      },
      {
        path: "/createStudent", name:'createStudent', component: CreateStudent
      },
      {
        path: "/modifyPassword", name:'modifyPassword', component: ModifyPassword
      },
      {
        path: "/importVipssStudent", name:'importVipssStudent', component: ImportVipssStudent
      },
      {
        path: "/studentDetail", component: StudentDetail
      },
      {
        path: "/teachingSchedule", component: TeachingSchedule
      },
      {
        path: "/createStore", name:'createStore', component: CreateStore
      },
      {
        path: "/storeList", name:'storeList', component: StoreList
      },
      {
        path: "/classList", component: ClassList
      },
      {
        path: "/oneByOneClassList", component: OneByOneClassList
      },
      {
        path: "/createClass", name:'createClass', component: CreateClass
      },
      {
        path: "/classStudentDetail", component: ClassStudentDetail
      },
      {
        path: "/createOneByOne", name:'createOneByOne', component: CreateOneByOne
      },
      {
        path: "/callList", component: CallList
      },
      {
        path: "/staffList", component: StaffList
      },
      {
        path: "/courseList", name:'courseList', component: CourseList
      },
      {
        path: "/createCourse", name:'createCourse', component: CreateCourse
      },
      {
        path: "/setMealList", component: SetMealList
      },
      {
        path: "/createSetMeal", name:'createSetMeal', component: CreateSetMeal
      },
      {
        path: "/salaryList", name:'salaryList', component: SalaryList
      },
      {
        path: "/setRules", name:'setRules', component: SetRules
      },
      {
        path: "/classRecord", name:'classRecord', component: ClassRecord
      },
      {
        path: "/vipssStudentDetail", name:'vipssStudentDetail', component: VipssStudentDetail
      },
      {
        path: "/vipssStudentCapterStatistics", name:'vipssStudentCapterStatistics', component: VipssStudentCapterStatistics
      }
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  routes
});

//抛出router之前，为其挂载路由导航守卫，to去哪，from从何来，next通行函数
// router.beforeEach((to, from, next) => {
//   if (to.path === "/login") return next();
//   const tokenStr = window.sessionStorage.getItem("token");
//   if (!tokenStr) return next("/login");
//   next();
// });

export default router;
